import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const StyledRegion = styled.div`
  position: relative;
  display: block;
  border-right: 1px solid #eee;
  padding: 0 30px 0;
  width: calc(100% / 3);
  text-align: center;
  @media all and (max-width: 700px) {
    padding: 30px 0;
    margin: 0 100px;
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #eee;
  }
  @media all and (max-width: 400px) {
    margin: 0 30px;
  }
  &:last-of-type {
    padding-right: 0;
    border: none;
  }
  label {
    cursor: pointer;
    font-weight: bold;
  }
  input {
    margin-right: 8px;
  }
  img {
    display: block;
    margin: 0 auto 30px;
    width: 85%;
    @media all and (max-width: 700px) {
      max-width: 200px;
    }
  }
`;

const Region = ({ checkId, copy, imgPrefix, img, onChange, value }) => (
  <StyledRegion>
    <label htmlFor={checkId}>
      <img src={`${imgPrefix}${img}`} alt="" />
      <input
        id={checkId}
        name={checkId}
        onChange={onChange}
        type="checkbox"
        checked={value === checkId}
      />
      {copy}
    </label>
  </StyledRegion>
);

Region.defaultProps = {
  value: ""
};

Region.propTypes = {
  checkId: PropTypes.string.isRequired,
  value: PropTypes.string,
  copy: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  img: PropTypes.string.isRequired,
  imgPrefix: PropTypes.string.isRequired
};
export default Region;
